<template>
  <section class="profile-intro-container">
    <div class="sm:pt-24">
      <Card class="profile-intro-card mx-auto max-w-488 box-shadow-none p-0 sm:box-shadow-sm sm:p-24 sm:mt-24">
        <img
          src="//images.ctfassets.net/wmwzystk5o45/2ssmjyxawilr37DN1hriUA/fdbdd1efc168a4fae85724d2cf511e88/profile-intro-mobile-top.webp"
          class="w-full h-auto sm:hidden"
          alt=""
        />
        <div class="p-16 sm:p-0">
          <h1 class="text-h2">{{ title }}</h1>
          <div v-for="(step, index) in steps" :key="index" class="mt-24">
            <div class="flex gap-16">
              <div>
                <div class="flex items-center gap-4">
                  <TickCircleIcon v-if="step.completed" color="#229150" :width="16" :height="16" />
                  <h2 class="text-strong-body">{{ step.title }}</h2>
                </div>
                <p class="text-body ml-20">{{ step.body }}</p>
              </div>
              <component :is="step.icon" :width="56" :height="56" class="min-w-56" />
            </div>
            <hr v-if="index < steps.length - 1" class="my-16 border-grey-divider-contrast sm:my-24" />
          </div>
        </div>
        <img
          src="//images.ctfassets.net/wmwzystk5o45/CeE9BHSiTx19ZNLcoP9cH/025cda561637239e0d336b27566c623f/profile-intro-mobile-bottom.webp"
          class="w-full h-auto sm:hidden"
          alt=""
        />
        <StickyButton class="sm:mt-24" value="Build my profile" size="medium" to="/sitter/signup/care-type" />
      </Card>
    </div>
  </section>
</template>

<script lang="ts">
import StickyButton from '@/components/sticky_button/StickyButton.vue';
import Card from '@/components/card/Card.vue';
import TickCircleIcon from '@/graphics/icons/TickCircleIcon.vue';
import SitterTeamIllustration from '@/graphics/illustrations/SitterTeamIllustration.vue';
import SitterProfileIllustration from '@/graphics/illustrations/SitterProfileIllustration.vue';
import IdVerificationIllustration from '@/graphics/illustrations/IdVerificationIllustration.vue';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'ProfileIntro',
  components: { StickyButton, Card, TickCircleIcon },
  computed: {
    title(): string {
      return 'Free, unlimited access to jobs in 2 more easy steps';
    },
    steps() {
      return [
        {
          title: 'Create your account',
          completed: true,
          body: "Nice work. It won't be visible to families until you do steps 2 & 3.",
          icon: SitterTeamIllustration,
        },
        {
          title: '2. Build your profile to share',
          body: "Add basic info like your skills and past experience that you'll use to apply for jobs",
          icon: SitterProfileIllustration,
        },
        {
          title: '3. Verify your identity',
          body: "Safety is our #1 priority. You'll need a government ID and your smart phone.",
          icon: IdVerificationIllustration,
        },
      ];
    },
  },
  mounted() {
    this.triggerSegmentEvent();
  },
  methods: {
    triggerSegmentEvent() {
      sendSegmentEvent('Intro Page Viewed', {});
    },
  },
};
</script>

<style lang="scss">
main.sitter-onboarding:has(.profile-intro-container) {
  @media only screen and (min-width: 480px) {
    background-color: theme('colors.primary.subdued');
  }
}

.sitter-onboarding {
  .profile-intro-container {
    @media only screen and (min-width: 480px) {
      background-image: url(//images.ctfassets.net/wmwzystk5o45/5eGp0qcVfy8MgZM8FXAOs2/7506e42f70573dacd5ff794bc3e6a63b/profile-intro-desktop.webp);
      background-size: contain;
      background-position: top center;
      background-repeat: no-repeat;
      min-height: 780px;
      margin-top: -24px;
    }
  }

  .profile-intro-card {
    background-color: transparent !important;
    @media (min-width: 480px) {
      background-color: white !important;
    }
  }
}
</style>
